import { Component, OnInit } from '@angular/core';
import { EdiMatlConv } from 'src/app/model/ediMatlConv';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { FileExportService } from 'src/app/services/file-export.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from 'src/app/services/excel-file.service';
import { PdfFileService } from 'src/app/services/pdf-file.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
declare var $: any;
@Component({
  selector: 'app-customer-material',
  templateUrl: './customer-material.component.html',
  styleUrls: ['./customer-material.component.css']
})
export class CustomerMaterialComponent implements OnInit {

  public loading: boolean;
  selectedpartner: string = "";
  selectedpartnerid: String = "";
  partners: any;
  search: string = "";
  selectedAllRow: boolean;
  config: any;
  count: number = 25;
  exportList: string[] = ['PDF', 'Excel'];
  selectedCustomerMaterials: any = [];
  exportModal: string;
  modalPopup: boolean = false;
  edimatlconv: EdiMatlConv[];
  serachdetails: EdiMatlConv[];
  edimatlconvdetails: EdiMatlConv[];
  clonededimatlconvDetails: EdiMatlConv[];
  public intialEdiMatlConvList: EdiMatlConv[];

  ismatlconvupdated: string = "";
  updatededimatlconv: boolean;
  ediTpMatlNum: string;
  ediTpMatlNumOriginal: string;
  sapMixDescr: string;
  sapPayerNum: string;
  ediTpConvFactor: number;
  ediTpUom: string;
  sapQtyConvFactor: number;
  sapQtyUom: string;
  ediTpPriceConvFactor: number;
  ediTpPriceUom: string;
  sapPriceConvFactor: number;
  sapPriceUom: string;
  sapMatlNum: string;

  iscreateionDateSortCollapsedUpArrow: boolean;
  iscreateionDateSortCollapsedDownArrow: boolean;

  isEdiTpMatlNumSortCollapsedUpArrow: boolean;
  isEdiTpMatlNumSortCollapsedDownArrow: boolean;

  isSapMatlNumSortCollapsedUpArrow: boolean;
  isSapMatlNumSortCollapsedDownArrow: boolean;

  isEdiTpPriceConvFactorSortCollapsedUpArrow: boolean;
  isEdiTpPriceConvFactorSortCollapsedDownArrow: boolean;

  isEdiTpConvFactorSortCollapsedUpArrow: boolean;
  isEdiTpConvFactorSortCollapsedDownArrow: boolean;

  isSapQtyConvFactorSortCollapsedUpArrow: boolean;
  isSapQtyConvFactorSortCollapsedDownArrow: boolean;

  isEdiTpUomSortCollapsedUpArrow: boolean;
  isEdiTpUomSortCollapsedDownArrow: boolean;

  isSapQtyUomSortCollapsedUpArrow: boolean;
  isSapQtyUomSortCollapsedDownArrow: boolean;

  issapMixDescrSortCollapsedUpArrow: boolean;
  issapMixDescrSortCollapsedDownArrow: boolean;

  isEdiTpPriceUomSortCollapsedUpArrow: boolean;
  isEdiTpPriceUomSortCollapsedDownArrow: boolean;

  isSapPriceConvFactorSortCollapsedUpArrow: boolean;
  isSapPriceConvFactorSortCollapsedDownArrow: boolean;

  isSapPriceUomSortCollapsedUpArrow: boolean;
  isSapPriceUomSortCollapsedDownArrow: boolean;

  constructor(private httpclientService: HttpclientService, public fileExportService: FileExportService,
    public appSettingService: AppSettingService, private pipe: PoOrderByPipe, public pdfFileService: PdfFileService,
    public excelFileService: ExcelFileService, public datePipe: DatePipe, private confirmDialogService: ConfirmDialogService, public datepipe: DatePipe) {
    this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };
    this.selectedpartner = '-1';

  }


  ngOnInit() {
    $(document).ready(
      () => {
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
          $(".searchInput").val("");
        })

      }
    )
    this.getPartnerDataList();

    //   this.loading=true;
    //   this.httpclientService.getPartnerListMSO().subscribe(
    //     data => {
    //       this.partners = data;
    //     }
    // );
    this.exportModal = this.appSettingService.exportList[0];
    this.onSearch();
    this.fileExportService.selectedEdiMatlConvData = [];
  }
  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.customerMatlDropDownGlobelList === null || this.appSettingService.customerMatlDropDownGlobelList === undefined) {
      this.httpclientService.getCustomerMatlDropdownList().subscribe(
        data => {
          this.appSettingService.customerMatlDropDownGlobelList = data;
          this.partners = data;
          this.loading = false;
        }
      );

      console.log('Partner is null from backend' + this.appSettingService.customerMatlDropDownGlobelList);
    } else {
      this.partners = this.appSettingService.customerMatlDropDownGlobelList;
      this.loading = false;
      console.log('Partner is not null from frontend' + this.appSettingService.customerMatlDropDownGlobelList);
    }
  }


  pressingOK() {
    this.search = "";
    // this.onSearch();
    this.ismatlconvupdated = "";
    this.ngOnInit();
    this.modalPopup = false;
    this.updatededimatlconv = false;



  }
  pressingCancel() {
    this.modalPopup = false;
  }


  ChangeSortOrder(exportData) {
    this.exportModal = exportData;
  }
  modalPopupExport: boolean = false;
  modalPopupString: string;
  pressingOKExport() {
    this.modalPopupExport = false;
  }
  export() {
    let flag: boolean;
    if (this.edimatlconvdetails == null || this.edimatlconvdetails == undefined || this.edimatlconvdetails.length == 0) {
      this.modalPopupString = "No Data to Export";
      this.modalPopupExport = true;
      return;
    }

    if (this.fileExportService.selectedEdiMatlConvData.length === 0) {
      flag = true;
      this.edimatlconv = [];
      this.edimatlconvdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edimatlconv.push(pdto);
      });
      this.edimatlconvdetails = this.edimatlconv;
      this.fileExportService.selectedEdiMatlConvData = this.edimatlconv;
    }
    if (this.exportModal === 'PDF') {
      this.pdfFileService.exportCustomerMaterialTable('Customer Material Table');
    } else if (this.exportModal === 'Excel') {
      this.selectedCustomerMaterials = [];
      this.fileExportService.selectedEdiMatlConvData.forEach(pdto => {
        if (pdto.rowCheck) {
          this.selectedCustomerMaterials.push({
            Create_Date: `` + `${this.datepipe.transform(pdto.createionDate, this.appSettingService.globelDatePickerInUSAFormat)}`, SAP_PAYER_NUM: `${pdto.sapPayerNum}`, EDI_TP_MATL_NUM: `${pdto.ediTpMatlNum}`, SAP_MATL_NUM: `${pdto.sapMatlNum}`, SAP_MIX_DESCR: (`${pdto.sapMixDescr}` == null || `${pdto.sapMixDescr}` == "null") ? "" : `${pdto.sapMixDescr}`,
            EDI_TP_CONV_FACTOR: `${pdto.ediTpConvFactor}`, EDI_TP_UOM: `${pdto.ediTpUom}`, SAP_QTY_CONV_FACTOR: `` + `${pdto.sapQtyConvFactor}`,
            SAP_QTY_UOM: `${pdto.sapQtyUom}`, EDI_TP_PRICE_CONV_FACTOR: `${pdto.ediTpPriceConvFactor}`, EDI_TP_PRICE_UOM: `${pdto.ediTpPriceUom}`
            , SAP_PRICE_CONV_FACTOR: `${pdto.sapPriceConvFactor}`, SAP_PRICE_UOM: `${pdto.sapPriceUom}`
          });
        }
      });
      this.excelFileService.exportCustomerMaterialTableExcel(this.selectedCustomerMaterials, 'Customer Material Table');
    }
    if (flag) {
      this.edimatlconv = [];
      this.edimatlconvdetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.edimatlconv.push(pdto);
      });
      this.edimatlconvdetails = this.edimatlconv;
      this.fileExportService.selectedEdiMatlConvData = [];
    }
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  changerecordperpage(value) {

    this.config.itemsPerPage = value;
    this.count = value;
  }
  filteredData: any[] = [];

  onChangePartner() {
    this.filteredData = [];
    this.selectedpartnerid = null
    if (this.intialEdiMatlConvList == undefined || this.intialEdiMatlConvList == null || this.intialEdiMatlConvList.length < 1) {
      this.loading = true;
      this.httpclientService.getEdiMatlConvDetails(this.search).then(
        (data) => {
          this.loading = false;
          this.serachdetails = data;
          this.intialEdiMatlConvList = data;
          this.edimatlconvdetails = [];
          this.edimatlconvdetails = this.serachdetails;
          this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
          this.clearAllSort();
          this.partners.forEach(element => {
            if (element.partnerName == this.selectedpartner)
              this.selectedpartnerid = element.partnerNumber;
          });
          this.intialEdiMatlConvList.forEach(element => {
            if (this.selectedpartnerid != undefined && this.selectedpartnerid != null && element.sapPayerNum == this.selectedpartnerid)
              this.filteredData.push(element);
          });
          this.edimatlconvdetails = [];
          if (this.filteredData != null && this.filteredData.length > 0) {
            this.serachdetails = this.filteredData;
            this.edimatlconvdetails = this.serachdetails;
            this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
            this.clearAllSort();
          } else if (this.selectedpartnerid == undefined || this.selectedpartnerid == null) {
            this.serachdetails = this.intialEdiMatlConvList;
            this.edimatlconvdetails = this.serachdetails;
            this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
            this.clearAllSort();
          }
        }
      )
    } else {
      this.partners.forEach(element => {
        if (element.partnerName == this.selectedpartner)
          this.selectedpartnerid = element.partnerNumber;
      });
      this.intialEdiMatlConvList.forEach(element => {
        if (this.selectedpartnerid != undefined && this.selectedpartnerid != null && element.sapPayerNum == this.selectedpartnerid)
          this.filteredData.push(element);
      });
      this.edimatlconvdetails = [];
      if (this.filteredData != null && this.filteredData.length > 0) {
        this.serachdetails = this.filteredData;
        this.edimatlconvdetails = this.serachdetails;
        this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
        this.clearAllSort();
      } else if (this.selectedpartnerid == undefined || this.selectedpartnerid == null) {
        this.serachdetails = this.intialEdiMatlConvList;
        this.edimatlconvdetails = this.serachdetails;
        this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
        this.clearAllSort();
      }
    }
  }

  cancelsearch() {
    this.isBlank = ""
    this.edimatlconvdetails = this.clonededimatlconvDetails;
  }
  onChangeSearch() {
    // this.selectedpartner="-1";
  }
  clearMessage() {
    this.isBlank = ""
  }
  isBlank: string = "";
  onSearch1(searchingData) {
    //this.selectedpartner="-1";
    if (searchingData.value === "" || searchingData.value === undefined || searchingData.value === null) {
      this.isBlank = "Please Enter Searching Data";
      return;
    }
    var filteredSerachDetails: EdiMatlConv[] = [];
    var inputSearchingData = searchingData.value;
    var inputSearchingDataCheck = inputSearchingData.toLowerCase();
    var sapMatlNum, ediTpMatlNum, sapMixDescr, sapPayerNum, ediTpConvFactor, ediTpUom, sapQtyConvFactor, sapQtyUom,
      ediTpPriceConvFactor, ediTpPriceUom, sapPriceConvFactor, sapPriceUom;

    for (var customerMaterial of this.edimatlconvdetails) {
      if (customerMaterial.sapMatlNum != null && customerMaterial.sapMatlNum != undefined && customerMaterial.sapMatlNum != "") {
        sapMatlNum = customerMaterial.sapMatlNum.toLowerCase();
      } else {
        sapMatlNum = "";
      }
      if (customerMaterial.ediTpMatlNum != null && customerMaterial.ediTpMatlNum != undefined && customerMaterial.ediTpMatlNum != "") {
        ediTpMatlNum = customerMaterial.ediTpMatlNum.toLowerCase();
      } else {
        ediTpMatlNum = "";
      }
      // if(customerMaterial.sapMixDescr != null && customerMaterial.sapMixDescr != undefined && customerMaterial.sapMixDescr !=""){
      //   sapMixDescr = customerMaterial.sapMixDescr.toLowerCase();
      //   }else{
      //     sapMixDescr="";
      //   }
      // if(customerMaterial.sapPayerNum != null && customerMaterial.sapPayerNum != undefined && customerMaterial.sapPayerNum !=""){
      //   sapPayerNum = customerMaterial.sapPayerNum.toLowerCase();
      //   }else{
      //     sapPayerNum="";
      //   }
      // if(customerMaterial.ediTpConvFactor !=0){
      //   ediTpConvFactor = customerMaterial.ediTpConvFactor;
      //   }else{
      //     ediTpConvFactor=0;
      //   }
      // if(customerMaterial.ediTpUom != null && customerMaterial.ediTpUom != undefined && customerMaterial.ediTpUom !=""){
      //   ediTpUom = customerMaterial.ediTpUom.toLowerCase();
      //   }else{
      //     ediTpUom="";
      //   }
      // if(customerMaterial.sapQtyConvFactor != 0){
      //   sapQtyConvFactor = customerMaterial.sapQtyConvFactor;
      //   }else{
      //     sapQtyConvFactor=0;
      //   }
      // if(customerMaterial.sapQtyUom != null && customerMaterial.sapQtyUom != undefined && customerMaterial.sapQtyUom !=""){
      //   sapQtyUom = customerMaterial.sapQtyUom.toLowerCase();
      //   }else{
      //     sapQtyUom="";
      //   }
      // if(customerMaterial.ediTpPriceConvFactor != 0){
      //   ediTpPriceConvFactor = customerMaterial.ediTpPriceConvFactor;
      //   }else{
      //     ediTpPriceConvFactor=0;
      //   }
      // if(customerMaterial.ediTpPriceUom != null && customerMaterial.ediTpPriceUom != undefined && customerMaterial.ediTpPriceUom !=""){
      //   ediTpPriceUom = customerMaterial.ediTpPriceUom.toLowerCase();
      //     }else{
      //       ediTpPriceUom="";
      //     }
      // if(customerMaterial.sapPriceConvFactor != 0){
      //   sapPriceConvFactor = customerMaterial.sapPriceConvFactor;
      //   }else{
      //     sapPriceConvFactor=0;
      //   }
      // if(customerMaterial.sapPriceUom != null && customerMaterial.sapPriceUom != undefined && customerMaterial.sapPriceUom !=""){
      //   sapPriceUom = customerMaterial.sapPriceUom.toLowerCase();
      //   }else{
      //     sapPriceUom="";
      //   }
      // if(sapPayerNum.includes(inputSearchingDataCheck)){
      //   filteredSerachDetails.push(customerMaterial);
      // }
      if (ediTpMatlNum.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(customerMaterial);
      }
      else if (sapMatlNum.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(customerMaterial);
      }
      // else if(sapMixDescr.includes(inputSearchingDataCheck)){
      //   filteredSerachDetails.push(customerMaterial);
      // }
      // else if(ediTpConvFactor != null  ){
      //   if(ediTpConvFactor.toString().includes(inputSearchingDataCheck)){
      //     filteredSerachDetails.push(customerMaterial);
      //   }

      // }
      // else if(ediTpUom != null){
      //   if(ediTpUom.includes(inputSearchingDataCheck)){
      //     filteredSerachDetails.push(customerMaterial);
      //   }

      // }
      // else if(sapQtyConvFactor != null){
      //   if(sapQtyConvFactor.toString().includes(inputSearchingDataCheck)){
      //     filteredSerachDetails.push(customerMaterial);
      //   }

      // }
      // else if(sapQtyUom.includes(inputSearchingDataCheck)){
      //   filteredSerachDetails.push(customerMaterial);
      // }
      // else if(ediTpPriceConvFactor != null){
      //   if(ediTpPriceConvFactor.toString().includes(inputSearchingDataCheck)){
      //     filteredSerachDetails.push(customerMaterial);
      //   }

      // }
      // else if(ediTpPriceUom.includes(inputSearchingDataCheck)){
      //   filteredSerachDetails.push(customerMaterial);
      // }else if(sapPriceConvFactor != null){
      //   if(sapPriceConvFactor.toString().includes(inputSearchingDataCheck)){
      //     filteredSerachDetails.push(customerMaterial);
      //   }

      // }
      // else if(sapPriceUom.includes(inputSearchingDataCheck)){
      //   filteredSerachDetails.push(customerMaterial);
      // }

    }
    let size = filteredSerachDetails.length;
    if (size != 0) {
      this.edimatlconvdetails = [];
      this.edimatlconvdetails = filteredSerachDetails;
    } else {
      this.isBlank = "No Record Found";
      this.edimatlconvdetails = this.intialEdiMatlConvList;
    }

  }

  onSearch() {
    this.clearAllSelection();
    // this.onChangeSearch();
    if (this.selectedpartner !== '-1') {
      this.isBlank = "";
      this.search = "";
      this.loading = true;
      this.httpclientService.getEdiMatlConvDetails(this.selectedpartner).then(
        data => {
          // this.selectedpartner="";

          this.serachdetails = data;
          this.intialEdiMatlConvList = data;
          this.edimatlconvdetails = [];
          this.edimatlconvdetails = this.serachdetails;
          this.clonededimatlconvDetails = Object.assign([{}], this.serachdetails);
          // this.selectedpartner=this.selectedpartner;
          this.clearAllSort();
          this.loading = false;
        }
      )
    } else {
      this.edimatlconvdetails = [];
      this.search = '';
    }
  }

  clearAllSort() {
    this.iscreateionDateSortCollapsedUpArrow = true;
    this.iscreateionDateSortCollapsedDownArrow = true;
    this.isEdiTpMatlNumSortCollapsedUpArrow = true;
    this.isEdiTpMatlNumSortCollapsedDownArrow = true;
    this.isSapMatlNumSortCollapsedUpArrow = true;
    this.isSapMatlNumSortCollapsedDownArrow = true;
    this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
    this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
    this.isEdiTpConvFactorSortCollapsedUpArrow = true;
    this.isEdiTpConvFactorSortCollapsedDownArrow = true;
    this.isSapQtyConvFactorSortCollapsedUpArrow = true;
    this.isSapQtyConvFactorSortCollapsedDownArrow = true;
    this.isEdiTpUomSortCollapsedUpArrow = true;
    this.isEdiTpUomSortCollapsedDownArrow = true;
    this.isSapQtyUomSortCollapsedUpArrow = true;
    this.isSapQtyUomSortCollapsedDownArrow = true;
    this.issapMixDescrSortCollapsedUpArrow = true;
    this.issapMixDescrSortCollapsedDownArrow = true;
    this.isEdiTpPriceUomSortCollapsedUpArrow = true;
    this.isEdiTpPriceUomSortCollapsedDownArrow = true;
    this.isSapPriceConvFactorSortCollapsedUpArrow = true;
    this.isSapPriceConvFactorSortCollapsedDownArrow = true;
    this.isSapPriceUomSortCollapsedUpArrow = true;
    this.isSapPriceUomSortCollapsedDownArrow = true;
  }
  clearedimatlconvSelection: EdiMatlConv[];
  clearAllSelection() {
    this.selectedAllRow = false;
    this.clearedimatlconvSelection = [];
    if (this.edimatlconvdetails != null && this.edimatlconvdetails.length > 0) {
      this.edimatlconvdetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.clearedimatlconvSelection.push(pdto);
      });
    }

    this.edimatlconvdetails = this.clearedimatlconvSelection;
  }

  onSelectAllCust(values: any) {

    this.edimatlconv = [];
    if (values.currentTarget.checked) {
      this.edimatlconvdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edimatlconv.push(pdto);
      });
      this.edimatlconvdetails = this.edimatlconv;
      this.fileExportService.selectedEdiMatlConvData = this.edimatlconv;
    } else {
      this.edimatlconvdetails.forEach(pdto => {
        console.log('...' + pdto.rowCheck);
        pdto.rowCheck = false;
        this.edimatlconv.push(pdto);
      });
      this.edimatlconvdetails = this.edimatlconv;
      this.fileExportService.selectedEdiMatlConvData = [];
    }

  }

  onSelect(selectedItem: any, values: any) {
    let checkStaus = true;
    if (values.currentTarget.checked) {

      this.fileExportService.selectedEdiMatlConvData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedEdiMatlConvData = this.fileExportService.selectedEdiMatlConvData.filter(obj => obj !== selectedItem);

    }

    if (this.fileExportService.selectedEdiMatlConvData.length === this.edimatlconvdetails.length) {
      this.selectedAllRow = true;
    } else {
      this.selectedAllRow = false;
    }


  }

  sortArry: EdiMatlConv[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.intialEdiMatlConvList = this.edimatlconvdetails;
    if (propertyName === 'createionDate') {
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, upDown);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.iscreateionDateSortCollapsedUpArrow = !this.iscreateionDateSortCollapsedUpArrow;
        this.iscreateionDateSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, upDown);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.iscreateionDateSortCollapsedDownArrow = !this.iscreateionDateSortCollapsedDownArrow;
        this.iscreateionDateSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'ediTpMatlNum') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpMatlNumSortCollapsedUpArrow = !this.isEdiTpMatlNumSortCollapsedUpArrow;
        this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpMatlNumSortCollapsedDownArrow = !this.isEdiTpMatlNumSortCollapsedDownArrow;
        this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      }
    }
    else if (propertyName === 'sapMatlNum') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapMatlNumSortCollapsedUpArrow = !this.isSapMatlNumSortCollapsedUpArrow;
        this.isSapMatlNumSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapMatlNumSortCollapsedDownArrow = !this.isSapMatlNumSortCollapsedDownArrow;
        this.isSapMatlNumSortCollapsedUpArrow = true;
      }
    }
    else if (propertyName === 'ediTpPriceConvFactor') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpPriceConvFactorSortCollapsedUpArrow = !this.isEdiTpPriceConvFactorSortCollapsedUpArrow;
        this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpPriceConvFactorSortCollapsedDownArrow = !this.isEdiTpPriceConvFactorSortCollapsedDownArrow;
        this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'ediTpConvFactor') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpConvFactorSortCollapsedUpArrow = !this.isEdiTpConvFactorSortCollapsedUpArrow;
        this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpConvFactorSortCollapsedDownArrow = !this.isEdiTpConvFactorSortCollapsedDownArrow;
        this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'sapQtyConvFactor') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapQtyConvFactorSortCollapsedUpArrow = !this.isSapQtyConvFactorSortCollapsedUpArrow;
        this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapQtyConvFactorSortCollapsedDownArrow = !this.isSapQtyConvFactorSortCollapsedDownArrow;
        this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'ediTpUom') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpUomSortCollapsedUpArrow = !this.isEdiTpUomSortCollapsedUpArrow;
        this.isEdiTpUomSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpUomSortCollapsedDownArrow = !this.isEdiTpUomSortCollapsedDownArrow;
        this.isEdiTpUomSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'sapQtyUom') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapQtyUomSortCollapsedUpArrow = !this.isSapQtyUomSortCollapsedUpArrow;
        this.isSapQtyUomSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapQtyUomSortCollapsedDownArrow = !this.isSapQtyUomSortCollapsedDownArrow;
        this.isSapQtyUomSortCollapsedUpArrow = true;
      }
    }
    else if (propertyName === 'sapMixDescr') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.issapMixDescrSortCollapsedUpArrow = !this.issapMixDescrSortCollapsedUpArrow;
        this.issapMixDescrSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.issapMixDescrSortCollapsedDownArrow = !this.issapMixDescrSortCollapsedDownArrow;
        this.issapMixDescrSortCollapsedUpArrow = true;
      }
    }
    else if (propertyName === 'ediTpPriceUom') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpPriceUomSortCollapsedUpArrow = !this.isEdiTpPriceUomSortCollapsedUpArrow;
        this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isEdiTpPriceUomSortCollapsedDownArrow = !this.isEdiTpPriceUomSortCollapsedDownArrow;
        this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      }
    }

    else if (propertyName === 'sapPriceConvFactor') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapPriceConvFactorSortCollapsedUpArrow = !this.isSapPriceConvFactorSortCollapsedUpArrow;
        this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapPriceConvFactorSortCollapsedDownArrow = !this.isSapPriceConvFactorSortCollapsedDownArrow;
        this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      }
    }
    else if (propertyName === 'sapPriceUom') {
      this.iscreateionDateSortCollapsedUpArrow = true;
      this.iscreateionDateSortCollapsedDownArrow = true;
      this.isEdiTpMatlNumSortCollapsedUpArrow = true;
      this.isEdiTpMatlNumSortCollapsedDownArrow = true;
      this.isSapMatlNumSortCollapsedUpArrow = true;
      this.isSapMatlNumSortCollapsedDownArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpPriceConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpConvFactorSortCollapsedUpArrow = true;
      this.isEdiTpConvFactorSortCollapsedDownArrow = true;
      this.isSapQtyConvFactorSortCollapsedUpArrow = true;
      this.isSapQtyConvFactorSortCollapsedDownArrow = true;
      this.isEdiTpUomSortCollapsedUpArrow = true;
      this.isEdiTpUomSortCollapsedDownArrow = true;
      this.issapMixDescrSortCollapsedUpArrow = true;
      this.issapMixDescrSortCollapsedDownArrow = true;
      this.isEdiTpPriceUomSortCollapsedUpArrow = true;
      this.isEdiTpPriceUomSortCollapsedDownArrow = true;
      this.isSapPriceConvFactorSortCollapsedUpArrow = true;
      this.isSapPriceConvFactorSortCollapsedDownArrow = true;
      this.isSapPriceUomSortCollapsedUpArrow = true;
      this.isSapPriceUomSortCollapsedDownArrow = true;
      this.isSapQtyUomSortCollapsedUpArrow = true;
      this.isSapQtyUomSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, true);
        console.log("property" + propertyName);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapPriceUomSortCollapsedUpArrow = !this.isSapPriceUomSortCollapsedUpArrow;
        this.isSapPriceUomSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.intialEdiMatlConvList, propertyName, false);
        this.edimatlconvdetails = [];
        this.edimatlconvdetails = this.sortArry;
        this.isSapPriceUomSortCollapsedDownArrow = !this.isSapPriceUomSortCollapsedDownArrow;
        this.isSapPriceUomSortCollapsedUpArrow = true;
      }
    }

  }


  enablingupdate(matlconvdto) {
    this.ismatlconvupdated = '';
    this.updatededimatlconv = true;
    this.ediTpMatlNumOriginal = matlconvdto.ediTpMatlNum;
    this.ediTpMatlNum = matlconvdto.ediTpMatlNum;
    this.sapMixDescr = matlconvdto.sapMixDescr;
    this.sapPayerNum = matlconvdto.sapPayerNum;
    this.ediTpConvFactor = matlconvdto.ediTpConvFactor;
    this.ediTpUom = matlconvdto.ediTpUom;
    this.sapQtyConvFactor = matlconvdto.sapQtyConvFactor;
    this.sapQtyUom = matlconvdto.sapQtyUom;
    this.ediTpPriceConvFactor = matlconvdto.ediTpPriceConvFactor;
    this.ediTpPriceUom = matlconvdto.ediTpPriceUom;
    this.sapPriceConvFactor = matlconvdto.sapPriceConvFactor;
    this.sapPriceUom = matlconvdto.sapPriceUom;
    this.sapMatlNum = matlconvdto.sapMatlNum;
  }

  updateedpar() {
    this.ismatlconvupdated = "";
    if (this.sapPayerNum == "" || this.sapPayerNum == null || this.sapPayerNum == undefined) {
      this.ismatlconvupdated = "Please Enter Payer";
      return;
    }
    if (this.ediTpMatlNum == "" || this.ediTpMatlNum == null || this.ediTpMatlNum == undefined) {
      this.ismatlconvupdated = "Please Enter EDI Material No.";
      return;
    }
    if (this.sapMatlNum == "" || this.sapMatlNum == null || this.sapMatlNum == undefined) {
      this.ismatlconvupdated = "Please Enter SAP Material No.";
      return;
    }
    let updatingedimatlconv: EdiMatlConv = new EdiMatlConv(this.sapMatlNum, this.ediTpMatlNum, this.sapMixDescr, this.sapPayerNum, this.ediTpConvFactor, this.ediTpUom, this.sapQtyConvFactor, this.sapQtyUom, this.ediTpPriceConvFactor, this.ediTpPriceUom, this.sapPriceConvFactor, this.sapPriceUom, this.ediTpMatlNumOriginal);
    this.loading = true;
    this.httpclientService.updateedimatlconv(updatingedimatlconv).subscribe(
      data => {
        this.ismatlconvupdated = data.isSaved;
        this.ediTpMatlNumOriginal = this.ediTpMatlNum;
        this.loading = false;
      }
    )

  }

  cancelUpdate() {
    // this.ismatlconvupdated="";
    this.isBlank = "";
    this.modalPopup = true;
  }

  clearField() {
    this.ismatlconvupdated = "";
  }

  showDialog() {
    this.ismatlconvupdated = "";
    this.confirmDialogService.confirmThis("Are you sure You want to Cancel?", function () {
      this.updatededimatlconv = false;
      this.getediMatlConv();
    }, function () {

    })
  }

  getediMatlConv() {
    this.loading = true;
    this.httpclientService.getEdiMatlConvDetails(this.search).then(
      data => {
        this.edimatlconvdetails = data;
        this.intialEdiMatlConvList = data;
        this.loading = false;
      }
    )
  }

}
